import React, { useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { i18n } from "./lang/i18n";
import ReactGA from "react-ga4";

import Footer from "./components/Footer";
import Navigation from "./components/Navigation";
import Cart from "./components/Cart";

import "react-toastify/dist/ReactToastify.css";
import "./App.scss";

function App() {
  ReactGA.initialize("G-L90D8DVY6R");

  const [language, setLanguage] = useState("en");
  const [searchParams, setSearchParams] = useSearchParams();

  const changeStatePage = (lang) => {
    document.body.className = "";
    document.body.classList.add(lang);

    if (lang === "ko") {
      document.title = "예약-오카야마 탐험";
    } else if (lang === "th") {
      document.title = "การจอง-สำรวจโอคายาม่า";
    } else if (lang === "tw") {
      document.title = "預訂-探索岡山";
    } else if (lang === "cn") {
      document.title = "预订-探索冈山";
    } else {
      document.title = "Reservation -Explore Okayama";
    }
  };

  useEffect(() => {
    const locale = searchParams.get("lang") || "en";

    i18n.changeLanguage(locale);
    setLanguage(locale);
    changeStatePage(locale);
  }, []);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    searchParams.set("lang", lang);
    setSearchParams(searchParams);
    changeStatePage(lang);
  };

  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    function onScroll() {
      let currentPosition = window.pageYOffset; // or use document.documentElement.scrollTop;
      setScrollTop(currentPosition <= 0 ? 0 : currentPosition);
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  useEffect(() => {
    if (window.self !== window.top) {
      const path = window.parent.location.pathname;
      const lang = ["en", "ko", "jp", "tw", "cn", "th"];
      const containsLang = lang.find((language) => path.includes(language));

      if (containsLang) {
        changeLanguage(containsLang);
      }
    }
  }, []);

  return (
    <div className={`App ${scrollTop === 0 ? "scrollTop" : ""}`}>
      <Navigation lang={language} />
      <Outlet context={[changeLanguage, language]} />
      <Cart language={language} changeLanguage={changeLanguage} />
      <ToastContainer />
      <Footer language={language} changeLanguage={changeLanguage} />
    </div>
  );
}

export default App;
